import Nullstack from 'nullstack';
export default function IconHomeCog({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-home-cog",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h1.6"
  }), "   ", Nullstack.element("path", {
    d: "M20.001 11.001l-8.001 -8.001l-9 9h2v7a2 2 0 0 0 2 2h4.159"
  }), "   ", Nullstack.element("circle", {
    cx: "18.001",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M18.001 14.5v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M18.001 20v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M21.032 16.25l-1.299 .75"
  }), "   ", Nullstack.element("path", {
    d: "M16.27 19l-1.3 .75"
  }), "   ", Nullstack.element("path", {
    d: "M14.97 16.25l1.3 .75"
  }), "   ", Nullstack.element("path", {
    d: "M19.733 19l1.3 .75"
  }), " ");
}